<template>
  <q-page fluid style="min-height: 0px">
    <div class="row">
      <div
        ref="titleOfPage"
        class="col-12 text-center bg-primary text-white q-pb-md"
      >
        <h4 class="q-py-none q-mb-none pwa-heading">Moisture Survey</h4>
      </div>
    </div>

    <scheduledSurveyForm
      ref="editForm"
      :pwaVersion="true"
      :surveyData="formData"
      @loadingStateChanged="(val) => (createLoading = val)"
    />
    <div class="row" v-if="currentUser">
      <div class="col-12">
        <b>Currently Logged-in as: {{ currentUser.email }}</b>
      </div>
      <div class="col-12">
        <q-btn @click="logout()" size="md" class="full-width" color="primary">
          Log Off
        </q-btn>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-12">
        <q-btn size="md" class="full-width" color="primary" @click="login()">
          Please Login here
        </q-btn>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <q-btn
          style="margin-top: 15px"
          size="md"
          class="full-width"
          outline
          @click="confirmDetails"
        >
          Proceed
        </q-btn>
      </div>
      <div class="col-12" v-if="!formData.hasOwnProperty('id')">
        <q-btn
          size="md"
          class="full-width"
          style="margin-top: 15px"
          outline
          :loading="createLoading"
          @click="scheduleForLater"
        >
          Scheduled for later
        </q-btn>
      </div>
    </div>
    <q-dialog v-model="confirmDetailsDialog">
      <q-card tile>
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Confirm Survey Details
            </div>
            <q-space />
            <q-btn
              color="black"
              round
              flat
              icon="mdi-close"
              @click="confirmDetailsDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <div class="row text-center">
            <div class="col-12">
              <p style="font-size: 15pt">
                Upper moisture limit: {{ confirmationData.upperLimit }}
              </p>
            </div>
            <div class="col-12">
              <p style="font-size: 15pt">
                Lower moisture limit: {{ confirmationData.lowerLimit }}
              </p>
            </div>
          </div>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="confirmSurveyDetails"
                class="full-width"
                color="positive"
                :loading="createLoading"
                label="Confirm & Position Sensor"
              >
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import scheduledSurveyForm from "@/components/scheduledSurveys/scheduledSurveyForm.vue";
import moment from "moment";

export default {
  components: {
    scheduledSurveyForm,
  },
  computed: {
    ...mapGetters(["currentUser", "currentUserData", "scheduledSurveys"]),
  },
  props: {
    source: String,
  },
  watch: {
    scheduledSurveys: function () {
      this.deepLinking();
    },
    $route: function () {
      this.deepLinking();
    },
  },
  data: () => ({
    formData: {
      upperLimit: 15,
      lowerLimit: 5,
    },
    confirmationData: {},
    confirmDetailsDialog: false,
    createLoading: false,
  }),
  beforeCreate() {
    this.$store.dispatch("loadScheduledSurveys");
  },
  mounted() {
    this.deepLinking();
    // if (!this.currentUserData && !this.currentUserData.id) {
    //   this.$swal({
    //     title: "Warning",
    //     text: "You are not currently logged in which will cause for some features to be unavailable, Do you want to login?",
    //     type: "warning",
    //     confirmButtonText: "Login",
    //     cancelButtonText: "Continue",
    //     showCancelButton: true,
    //     confirmButtonColor: "#3284E3",
    //   }).then((res) => {
    //     if (res.value) {
    //       // There was a bug where the background overlay didn't disappear
    //       setTimeout(() => {
    //         this.$auth.loginWithPopup();
    //       }, 150);
    //     }
    //   });
    // }
  },
  methods: {
    async confirmDetails() {
      let result = await this.$refs.editForm.$refs.surveyForm.validate();
      if (result) {
        this.confirmationData = JSON.parse(
          JSON.stringify(this.$refs.editForm.formData)
        );

        this.$store.dispatch("setCurrentSurvey", this.confirmationData);
        this.confirmSurveyDetails();
        // this.confirmDetailsDialog = true;
      }
    },
    deepLinking() {
      if (this.$route.params.hasOwnProperty("id")) {
        let survey = this.scheduledSurveys.find(
          (ss) => ss.id == this.$route.params.id
        );
        if (survey != undefined) {
          this.formData = JSON.parse(JSON.stringify(survey));
        }
      } else {
        this.formData = {
          upperLimit: 15,
          lowerLimit: 5,
        };
      }
    },
    scheduleForLater() {
      this.$refs.editForm.create().then(() => {
        this.$router.push("/mobile-view/scheduled-mp-surveys");
      });
    },
    async confirmSurveyDetails() {
      if (this.formData.hasOwnProperty("id")) {
        this.$router.push("/mobile-view/survey-progress");
      } else {
        this.$refs.editForm.create().then(() => {
          this.$router.push("/mobile-view/survey-progress");
        });
      }
    },
    login() {
      this.$auth.loginWithPopup();
    },
    logout() {
      this.$store.dispatch("logout");
      setTimeout(() => {
        this.$auth.logout({
          returnTo: window.location.origin,
        });
      }, 10);
    },
  },
};
</script>
